export default __webpack_public_path__ + "static/media/ok.47a6eb50.svg";